import * as types from './types'
import {createAction} from '../../tools/createAction'

export function setMessageStatus (state) {
  return {
    type: types.SHOW_MESSAGE,
    payload: state

  }
}
export function setPathName (state){
  return {
    type:"setPathName",
    payload:state
  }
}
// 通知redux，消息数量变化了
export function notifyChange(timestamp) {
  return {
    type: types.MESSAGE_COUNT,
    payload: timestamp

  }
}
// 通知消息管理（记录未读数量）
export function notifyCountChange (state) {
  return {
    type: types.NOTIFY_COUNT,
    payload: state
  }

}
// 活动霸屏-轮播图-列表
export const activityList = createAction(types.ACTIVITY_ACTION,'activityList');

export function bapingChange (status) {
  return{
    type:types.BAPING_ACTION,
    payload:status
  }
}

